// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class OrganizationalUnit extends TrackingModel {
	public OrganizationalUnitId: number = 0;
	public Name: string = "";
	public Description?: string;
	public AvatarBlobPath?: string;
}